import { PercentPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, EventEmitter, ANALYZE_FOR_ENTRY_COMPONENTS } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../../services/api.service';
import { ComponentService } from '../../../services/component.service';
import { AllDB, AllLicenze, AllLicenzeInstallate, DatiService, PopulationByRegion } from '../../../services/dati.service';
import { Utenteservice } from '../../../services/utente.service';
import { AnaUtentiComponent } from '../../ana-utenti/ana-utenti.component';
import { confirm } from 'devextreme/ui/dialog';
import { alert } from "devextreme/ui/dialog"
import { Router } from '@angular/router';
import { _tbOption } from '../../../class/userinterface';
import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import notify from 'devextreme/ui/notify';
import { AnteprimaPDfComponent } from '../../../components/shared/anteprima-pdf/anteprima-pdf.component';
import { NicaInfoAnagraficaAziendaComponent } from '../../../components/anagrafiche/nica-info-anagrafica-azienda/nica-info-anagrafica-azienda.component';
import { AppInfoService } from '../../../services/app-info.service';
import { environment } from '../../../../environments/environment';
import { messagefromComponent } from '../../../class/appinterface';
import { NicaAnagraficaComponent } from '../../../components/nica-anagrafica/nica-anagrafica.component';
import { NicaGestioneAziendaComponent } from '../../../components/nica-gestione-azienda/nica-gestione-azienda.component';
import { NicaFormComponent } from '../../../components/nica-form/nica-form.component';
import { C } from '@angular/cdk/keycodes';




@Component({
  selector: 'app-owner',
  templateUrl: './owner.component.html',
  styleUrls: ['./owner.component.css', '../../ana-soggetto/ana-soggetto.component.css']
})
export class OwnerComponent implements OnInit, AfterViewInit {
  @ViewChild('dynamicInsert', { static: false, read: ViewContainerRef }) dynamicInsert: ViewContainerRef;
  @ViewChild('dynamicInsertPopUp', { static: false, read: ViewContainerRef }) dynamicInsertPopUp: ViewContainerRef;
  @ViewChild('gridLicenze', { static: false, read: ViewContainerRef }) gridLicenze: ViewContainerRef;
  @ViewChild('gridAziende', { static: false }) gridAziende: NicaAnagraficaComponent;

  /** Form Dettagli Licenza */
  @ViewChild('licenzaForm', { static: false }) licenzaForm: NicaFormComponent;

  /** Form Attivazione Licenza (attualemnte sostiuisce l'Add Row Button)*/
  @ViewChild('attivaLicenzaForm', { static: false }) attivaLicenzaForm: NicaFormComponent;


  //@ViewChild('space', { static: true }) spaces: DxPieChartModule;
  pipe: any = new PercentPipe('it-IT');
  populationByRegions: PopulationByRegion[];
  allDb: AllDB[];
  allLicenze: AllLicenzeInstallate[];
  currentLicenza: AllLicenzeInstallate;
  allDB: AllDB;
  currentDB: AllDB;
  AziendaCorrente;
  customizeTooltip;


  popupLicenza = false;
  popupAttivaLicenza = false;
  popupAttivaDB = false;

  titoloDinamico?: string;

  localhost: boolean = false;
  dataLicenza: any;
  dataDB: any;
  popupComponentTitle;
  popupComponentVisible;
  imagSource = "../../../assets/images/images" + ".jpg"
  emailButtonOptions: any;
  buttonOptionsClose: any;
  emailButtonOptionsDB: any;
  closeButtonOptions: any;
  closeButtonOptionsDB: any;
  positionOf: string;
  tipoutente = "";
  descrizionetipoutente = "";
  licenza = "";
  descr_licenza;
  nomeutente;
  userlogin;
  overlayTitle;
  toolbarOption: _tbOption[];
  helpPage: string;


  bottoniAttivaLicenza = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Attiva',
      icon: "key",
      event: 'attiva',
      cssClass: 'salvaButtonExcelExporter',
      class: 'salvaButtonExcelExporter',
    },
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Annulla',
      icon: "glyphicon glyphicon icon-annulla-form",
      event: 'annulla',
      cssClass: 'escludiQuesto'
    },
  ];

  bottoniLicenza = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Salva',
      icon: "glyphicon mdi mdi-content-save-outline",
      event: 'salva',
      cssClass: 'salvaButtonExcelExporter',
      class: 'salvaButtonExcelExporter',
    },
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Annulla',
      icon: "glyphicon glyphicon icon-annulla-form",
      event: 'annulla',
      cssClass: 'escludiQuesto'
    },
  ];

  buttonOptions: any = {
    text: 'Crea',
    type: 'normal',
    stylingMode: "contained",
    useSubmitBehavior: true,
  };
  InAttesaOpen: boolean;
  timeInterval: NodeJS.Timer;
  isOpen: any;
  showToolBar: boolean;


  constructor(private appInfoService: AppInfoService, private router: Router, private componentService: ComponentService, private spinner: NgxSpinnerService, private appService: Apiservice, public utenteService: Utenteservice, private datiService: DatiService, private componentFactoryResolver: ComponentFactoryResolver,
    private _overlaySidePanelService: OverlaySideFormService,
    private viewContainerRef: ViewContainerRef) {

    const t = this;
    const that = this;
    //this.employees = service.getEmployees(); emailButtonOptions


    //descr_licenza
    this.utenteService.changedUser.subscribe(function (value) {
      console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww ", value);
      //alert(value.nomeCompleto,"Change User Owner")
      setTimeout(() => {
        t.nomeutente = value.nomeCompleto;
        t.tipoutente = value.tipoutente;
        t.descr_licenza = value.descr_licenza;
        t.licenza = value.licenza;
        t.userlogin = value.userName;
      }, 200);

    })



    this.componentService.castMessage.subscribe(function (value) {
      if (value == "AttivalicenzaComponent") {
        t.popupComponentVisible = false;
      }
    });
  }

  onFormSubmit = function (e) {
    this.CreaDB();
    e.preventDefault();

  };



  deleteDbClick(ev, item) {
    let result = confirm("<i>Davvero vuoi eliminare l'azienda <strong>" + item.descrizione + "</strong> ?</i>", "Eliminazione Azienda");
    let t = this;
    //this.currentDB.id
    result.then((dialogResult) => {
      if (dialogResult)
        //alert(t.currentLicenza.id,"wwww");    

        this.appService.removeDB(item.id).then(response => {
          if (response['codeMessage'] < 0) {
            alert(response['descrMessage'], "Cancellazione Licenza")
          } else {
            alert(response['descrizione'] + "Azienda Rimossa con successo", "Cancellazione Licenza");
            setTimeout(() => {
              this.getAllDbOnLine();
            }, 200);
            //this.allLicenze=this.datiService.getAllLicenze();  
            //this.currentLicenza=this.allLicenze[0];   
            //this.dynamicInsert.clear();
            //this.step=1;
            return;
          }

        })
          .catch((err: HttpErrorResponse) => {
            //this.appService.parseHttpErrorResponse(err);                        
          })
    });
    ev.event.stopPropagation();

  }
  deleteLicenzeClick(ev, item) {
    alert("<img width='64px' style='margin-right:10px' src='assets/images/happy.png'/><i>Mi Spaice ma per il momento la funzione è disabilitata</i>", "");
    ev.event.stopPropagation();
    return;
    let result = confirm("<img width='64px' src='assets/images/happy.png'/><i>Mi Spaice ma per il momento la funzione è disabilitata</i>", "Eliminazione Licenza");
    let t = this;
    result.then((dialogResult) => {
      if (dialogResult)
        //alert(t.currentLicenza.id,"wwww");    

        this.appService.removeLicenza(item.id).then(response => {
          if (response['codeMessage'] < 0) {
            alert(response['descrMessage'], "Cancellazione Licenza")
          } else {
            alert(response['descrizione'] + " Rimossa con successo", "Cancellazione Licenza");
            this.allLicenze = this.datiService.getAllLicenze();
            this.currentLicenza = this.allLicenze[0];
            this.dynamicInsert.clear();
            //this.step=1;
            return;
          }

        })
          .catch((err: HttpErrorResponse) => {
            //this.appService.parseHttpErrorResponse(err);                        
          })
    });
    ev.event.stopPropagation();
  }


  CreaDB() {

    this.appService.CreaDB(this.dataDB.Alias, this.dataDB.Descrizione, this.dataDB.usernameRentri, this.dataDB.passwordRentri,
      this.dataDB.codiceFiscaleAzienda).then(response => {
        if (response['codeMessage'] < 0) {
          alert(response['descrMessage'], "Creazione Azienda")
        } else {
          alert(response['descrizione'] + " Creata con successo", "Creazione Azienda");
          this.popupAttivaDB = false;
          //this.dynamicInsert.clear();
          setTimeout(() => {
            this.getAllDbOnLine();
          }, 200);

          this.dataDB.Alias = "",
            this.dataDB.Descrizione = "";
          this.dataDB.usernameRentri = "",
            this.dataDB.passwordRentri = "",
            this.dataDB.codiceFiscale = ""
          //this.step=1;
          return;
        }

      })
      .catch((err: HttpErrorResponse) => {
        //this.appService.parseHttpErrorResponse(err);                        
      })


  }
  async optionalButtonClickAziende(e: any) {



    if (typeof e == 'object') {

      switch (e.name) {

        case 'aziendaUtenti': {
          this.currentDB = e.row.data;
          this.AziendaCorrente = this.currentDB.id;
          let data = {
            titolo: this.currentDB.descrizione,
            service: 'utentiDiOwner'
          }
          //console.log('currentDB',this.currentDB.descrizione

          this.appService.SetDBLavoro(this.currentDB.id).then(response => {
            this.spinner.hide();
            this._overlaySidePanelService.setTitle("Utenti:  " + this.currentDB.descrizione);
            this._overlaySidePanelService.setHelp("CreazioneUtente.html");

            this._overlaySidePanelService.setPopupHeight('730px');
            this._overlaySidePanelService.setContent(AnaUtentiComponent);
            this._overlaySidePanelService.sendDataToComponent(data);
            //this._overlaySidePanelService.
            this._overlaySidePanelService.show();

            setTimeout(
              () => {
                (this._overlaySidePanelService._hrefComponent.instance.onChiusuraUtentiEmitter as EventEmitter<any>).subscribe(
                  (evt) => {


                    if (evt == 'chiudi')
                      this._overlaySidePanelService.close();

                  }

                );
              }, 500
            )


          }).catch((err: HttpErrorResponse) => {
            this.spinner.hide();
          });
        } break;

        case 'databaseConfig': {

          this.currentDB = e.row.data;
          this.AziendaCorrente = this.currentDB.id;

          console.log('fammi vedere currentDb', this.currentDB);

          this.appService.GetApi(`LicenzaAzienda/GetByCodLicenzaIdAzienda?codLicenza=${this.utenteService.InfoUtenteConnesso.licenza}&idAzienda=${this.AziendaCorrente}`)
            .then(async (x: any) => {

              const data = {
                service: 'configurazioneDatabaseAziendale',
                api: 'configurazioneDatabaseAziendale',
                toolbarTop: false,
                toolbarBottom: true,
                disableEditForm: false,
                isEdit: false,
                heightForm: 232,
                type: "simple",
                remoteOperation: false,
                dataJson: {
                  dbInstance: x.dbInstance,
                  dbName: x.dbName,
                  dbUser: x.dbUser,
                  dbPassword: x.dbPassword,
                  quotaConsulentiInMegaBytes: x.quotaConsulentiInMegaBytes,
                  numeroMaxDispositiviMobili: x.numeroMaxDispositiviMobili
                },
                CustomButtonSetForm: [
                  {
                    location: 'after',
                    stylingMode: 'text',
                    widget: 'dxButton',
                    locateInMenu: 'never',
                    text: 'Salva',
                    icon: 'glyphicon mdi mdi-content-save-outline',
                    event: 'conferma',
                  },
                  {
                    location: 'after',
                    stylingMode: 'text',
                    widget: 'dxButton',
                    locateInMenu: 'never',
                    text: 'Reset',
                    icon: 'glyphicon glyphicon icon-ccw',
                    event: 'reset',
                  },
                  {
                    location: 'after',
                    stylingMode: 'text',
                    widget: 'dxButton',
                    locateInMenu: 'never',
                    text: 'Annulla',
                    icon: 'glyphicon glyphicon icon-annulla-form',
                    event: 'annulla',
                  },

                ],
                standardBtnBottom: []
              }

              let newGuid = Math.random().toString().replace("0.", "")

              this.componentService.setNewPopUp(newGuid, 'NewNicaFormComponent', null, '500', null, data, false, true, 'Configurazione Database Aziendale', 'top')

              this.componentService.outputComponent.subscribe(async (res) => {

                if (res.name === 'return' || res.name == 'annulla' && res.guid == newGuid) {
                  return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
                }

                if (res.name === 'conferma' && res.guid == newGuid) {


                  await this.appService.PutApi(`LicenzaAzienda?codLicenza=${this.utenteService.InfoUtenteConnesso.licenza}&idAzienda=${this.AziendaCorrente}`, data.dataJson)

                  notify({
                    message: 'Configurazione Database modificata con successo!',
                    height: 45,
                    width: 250,
                    position: 'center center'
                  }, 'success', 3000);


                  return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
                }

                if (res.name === 'reset' && res.guid == newGuid) {

                  data.dataJson.dbInstance = null;
                  data.dataJson.dbName = null;
                  data.dataJson.dbUser = null;
                  data.dataJson.dbPassword = null;
                  data.dataJson.numeroMaxDispositiviMobili = null;
                  data.dataJson.quotaConsulentiInMegaBytes = null;

                  await this.appService.PutApi(`LicenzaAzienda?codLicenza=${this.utenteService.InfoUtenteConnesso.licenza}&idAzienda=${this.AziendaCorrente}`, data.dataJson)

                  notify({
                    message: 'Configurazione Database ripristinata con successo!',
                    height: 45,
                    width: 250,
                    position: 'center center'
                  }, 'success', 3000);


                  return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
                }

              });


              // this.appService.GetApi(`LicenzaAzienda/GetByCodLicenzaIdAzienda?codLicenza=${this.utenteService.InfoUtenteConnesso.licenza}&idAzienda=${this.AziendaCorrente}`).then(x=>{

              //   console.log('dimmi cosa dice x', x);



            }).catch((err: HttpErrorResponse) => {
              console.error('Errore nella richiesta:', err)
            });

break
        }

         case 'xmlConsumptionLog': {

          this.currentDB = e.row.data;
          this.AziendaCorrente = this.currentDB.id;

          console.log('fammi vedere currentDb', this.currentDB);

          
          this.appService.GetApi(`RenEsportazioni/GetSentXMLSizeInMB?idLicenza=${this.utenteService.InfoUtenteConnesso.licenza}&idAzienda=${this.AziendaCorrente}`)
            .then(async (x: number) => {
              const instanceData = {
                powerInfo: {
                  primary: x,
                }
              };

              let newGuid = Math.random().toString().replace("0.", "")

              this.componentService.setNewPopUp(newGuid, 'GaugesOwnerComponent', null, '800', null, instanceData, false, true, 'Consumo Registri XML', 'top')

              this.componentService.outputComponent.subscribe(async (res) => {

                if (res.name === 'return' || res.name == 'annulla' && res.guid == newGuid) {
                  return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
                }


              });

            });

break


        }
      }
    }
  }
  optionalButtonClickLicenze(e: any) {


    if (typeof e == 'object') {


      switch (e.name) {


        case 'licenzaUtenti': {
          this.currentLicenza = e.row.data;
          let data = {
            //titolo: this.currentLicenza.id + " " + this.currentLicenza.descrizione
            service: 'utentiDiOwner',
            titolo: this.currentLicenza.descrizione
          }

          this.appService.SetLicenzaLavoro(this.currentLicenza.id).then(response => {
            this.spinner.hide();

            this._overlaySidePanelService.setPopupHeight('730px');
            this._overlaySidePanelService.setContent(AnaUtentiComponent);
            this._overlaySidePanelService.setTitle("Utenti:  " + this.currentLicenza.descrizione);
            this._overlaySidePanelService.setHelp("CreazioneUtenteSuperadmin.html");
            this._overlaySidePanelService.sendDataToComponent(data);
            this._overlaySidePanelService.setToolBarVisible(true);


            this._overlaySidePanelService.show();

            setTimeout(
              () => {
                (this._overlaySidePanelService._hrefComponent.instance.onChiusuraUtentiEmitter as EventEmitter<any>).subscribe(
                  (evt) => {

                    if (evt == 'chiudi')
                      this._overlaySidePanelService.close();

                  }

                );
              }, 500);
          }).catch((err: HttpErrorResponse) => {
            this.spinner.hide();
          });
        } break;

        case 'licenzaDetail': {

          console.warn(e);


          this.titoloDinamico = 'Licenza: ' + e.row.data['id'];

          setTimeout(
            () => {

              this.licenzaForm.formEdit.instance.updateData('id', e.row.data['id']);
              this.licenzaForm.formEdit.instance.updateData('descrizione', e.row.data['descrizione']);
              this.licenzaForm.formEdit.instance.updateData('codiceFiscale', e.row.data['codiceFiscale']);
              this.licenzaForm.formEdit.instance.updateData('isAttiva', e.row.data['isAttiva']);

            }, 500
          )


          this.popupLicenza = true;


        } break;
      }
    }
  }


  attivaLicenza() {


    let dt: messagefromComponent = {
      destComponent: 'gridLicenze',
      traceMessage: 'refresh',
      codeMessage: 0
    }

    let codiceAssistenza = this.attivaLicenzaForm.formEdit.formData['codiceAssistenza']
    let obj = {...this.attivaLicenzaForm.formEdit.formData}

    this.appService.CreaLicenza(obj,codiceAssistenza).then(response => {
      if (response['codeMessage'] < 0) {
        alert(response['descrMessage'], "Attivazione Licenza")
      } else {

        notify({
          message: response['descrizione'] + " Attivata",
          height: 45,
          width: 250,
          position: 'center center'
        }, "success", 2000);



        this.appService.GetUserInfo().then(response => {
          this.allLicenze = response['licenze'];
          this.utenteService.SetUserLicenze(response['licenze']);
          this.allLicenze = this.datiService.getAllLicenze();
          this.componentService.emitMessage(dt);

        }).catch((err: HttpErrorResponse) => {
          //this.popupAttivaLicenza = false;
          return;
        });

        this.popupAttivaLicenza = false;
        //this.step=1;
        return;
      }

    })
      .catch((err: HttpErrorResponse) => {

      });
  }



  logga(e: any) {

    if (e == 0) {
      this.utenteService.LogOut();
      this.router.navigate(['/'], {
        skipLocationChange: true,
        replaceUrl: true
      }).then(() => {
        window.location.reload();
      });
    }

    if (e == 10) {
      this.popupAttivaDB = true;
    }

    if (e == 11) {

      //this.dataLicenza.Codice="";
      this.popupAttivaLicenza = true;
      /*
      const factory2 = this.componentFactoryResolver.resolveComponentFactory(AttivalicenzaComponent);
        this.popupComponentTitle="Attivazione Licenza"   
        this.popupComponentVisible=true;
        setTimeout(() => {   
          this.dynamicInsertPopUp.clear();
          this.dynamicInsertPopUp.createComponent(factory2, 0);
          
        }, 1000);*/
    }

    //
  }
  getAllDbOnLine() {
    this.appService.GetAllDb().then(response => {
      if (response['codeMessage'] < 0) {
      } else {
        this.allDB = <AllDB>response;
        this.currentDB = this.allDB[0];
        //alert(response['descrMessage'],"Attivazione Licenza")
        return;
      }

    })
      .catch((err: HttpErrorResponse) => {
        //this.appService.parseHttpErrorResponse(err);                        
      });
  }
  ngAfterViewInit() {
    // this.componentService.castMessage.subscribe(message=>this.messaggioFromComponent(message));

    this.toolbarOption = [{ position: "vertical", width: "", background: "ebebeb", bootstrapClass: 'col-md-1' }];
    this.showToolBar = false


    setTimeout(() => {
      //this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);

      if (this.utenteService.InfoUtenteConnesso.idtipoutente == 1) {
        console.log("vedi le licenze ", this.utenteService.InfoUtenteConnesso.licenze)
        this.allLicenze = this.datiService.getAllLicenze();
        this.currentLicenza = this.allLicenze[0];
        return;
      }
      //currentDB

      this.appService.GetAllDb().then(response => {
        if (response['codeMessage'] < 0) {
        } else {
          this.allDB = <AllDB>response;
          this.currentDB = this.allDB[0];
          //alert(response['descrMessage'],"Attivazione Licenza")
          return;
        }

      })
        .catch((err: HttpErrorResponse) => {
          //this.appService.parseHttpErrorResponse(err);                        
        });


    }, 1000);



    this.populationByRegions = this.datiService.getPopulationByRegions();
    this.customizeTooltip = (arg: any) => ({
      text: `${arg.valueText} - ${this.pipe.transform(arg.percent, '1.2-2')}`,
    });

  }
  Help(e) {
    //
    alert("Si dovrebbe gestire l' <strong>help</strong> della form", "HELP");
  }

  AllEventAziende = (e) => {


    if (e.name == "onEditorPrepared") {

      e.cancel = true;

      let instanceData = {
        destComponent: 'NicaGestioneAzienda',
        traceMessage: 'datiAzienda',
        dati: e.data,
      };

      const guid = Math.random().toString().replace("0.", "")
      let title = 'Dati Azienda';
      this.componentService.setNewPopUp(guid, 'NicaGestioneAziendaComponent', [], '1250', null, instanceData, false, true, title, 'top')

      this.componentService.outputComponent.subscribe(currentOutput => {
        console.log("Anteprima output ", currentOutput)

        if (currentOutput == "confermaAzienda") {



          this.componentService.destroyCurrentOpenPopUpByGuid(guid);
          this.componentService.destroyOutputComponent();

          this.gridAziende.refresh();

          this.gridAziende.griglia.instance.refresh();
        }


        if (currentOutput == "annullaAzienda") {
          this.componentService.destroyCurrentOpenPopUpByGuid(guid);
          this.componentService.destroyOutputComponent();
        }
      }
      );


      // e.cancel=true;

      // console.log(e)

      // this._overlaySidePanelService.setTitle('Dati Azienda');
      // this._overlaySidePanelService.setContent(NicaGestioneAziendaComponent);

      // this._overlaySidePanelService.setPopupHeight(668);
      // this._overlaySidePanelService.setPopupWidth(1250);

      // let data = [
      //   {
      //     destComponent: 'NicaGestioneAzienda',
      //     traceMessage: 'datiAzienda',
      //     dati: e.data,

      //   }
      // ]

      // this._overlaySidePanelService.sendDataToComponent(data);

      // this._overlaySidePanelService.show();

      // setTimeout(
      //   ()=>{
      //     (this._overlaySidePanelService._hrefComponent.instance.onToolbarButtonClick as EventEmitter<any>).subscribe(
      //       (valore:string)=>{
      //         console.warn(valore);


      //         if(valore == 'confermaAzienda'){

      //           //this.gridAziende.refresh();

      //           this.gridAziende.griglia.instance.refresh();

      //           this._overlaySidePanelService.close();

      //         }

      //         if(valore== 'annullaAzienda'){

      //           this._overlaySidePanelService.close();


      //         }

      //       }
      //     )
      //   },200
      // );



      /*
      if (e.dataField == "descrizione") {

        setTimeout(function () {
          e.component.focus(e.editorElement);
        }, 100);
      }
      */

    }

    if (e.name == "onEditorPreparing") {

      //e.cancel=true;

    }
    if (e.name == "onInitNewRow") {


      e.cancel = true;



      const guid = Math.random().toString().replace("0.", "")
      let title = 'Dati Azienda';
      this.componentService.setNewPopUp(guid, 'NicaGestioneAziendaComponent', [], '1250', null, null, false, true, title, 'top', 'CreazioneAzienda.html')

      this.componentService.outputComponent.subscribe(currentOutput => {
        console.log("Anteprima output ", currentOutput)

        if (currentOutput == "confermaAzienda") {



          this.componentService.destroyCurrentOpenPopUpByGuid(guid);
          this.componentService.destroyOutputComponent();

          this.gridAziende.refresh();

          this.gridAziende.griglia.instance.refresh();
        }


        if (currentOutput == "annullaAzienda") {
          this.componentService.destroyCurrentOpenPopUpByGuid(guid);
          this.componentService.destroyOutputComponent();
        }
      }
      );


      //e.data.isAttiva=true;
    }



  }


  AllEventLicenze = (e) => {

    //e.cancel = true;
    //
    if (e.name == "onRowUpdating") {
      e.cancel = true;
      console.log("UPDATE LICENZA ", e)
      if (e.newData) {
        this.spinner.show();
        e.newData.CodeLicenza = e.oldData.id;
        console.log("ecco cosa passo ", e.newData);
        if (e.newData.isAttiva != undefined) {
          this.appService.AbilitaDisabilitaLicenza(e.newData).then(response => {
            this.spinner.hide();
            let dt: messagefromComponent = {
              codeMessage: 0,
              destComponent: 'gridLicenze',
              traceMessage: 'refresh'
            }
            this.componentService.emitMessage(dt);





          }).catch((err: HttpErrorResponse) => {

            this.spinner.hide();
            console.log(err);
          });

        }
        this.popupAttivaLicenza = false;
        return e;
      }
      e.cancel = true;
      return;
      alert("nuovo", "nuovo");
    }

    if (e.name == "onInitNewRow") {
      e.cancel = true;
      this.popupAttivaLicenza = true;
      return;
      alert("nuovo", "nuovo");
    }

    if (e.name == "onEditorPrepared") {
      e.cancel = true;

    }

  }


  listSelectionChangedDB = (e) => {
    //this.currentDB = e.addedItems[0];    

    this.currentDB = e.itemData;
    this.AziendaCorrente = this.currentDB.id;

    this.appService.SetDBLavoro(this.currentDB.id).then(response => {
      this.spinner.hide();

      this._overlaySidePanelService.setTitle("Utenti");
      this._overlaySidePanelService.setPopupHeight('730px');

      this._overlaySidePanelService.setContent(AnaUtentiComponent);
      this._overlaySidePanelService.show();

      setTimeout(
        () => {
          (this._overlaySidePanelService._hrefComponent.instance.onChiusuraUtentiEmitter as EventEmitter<any>).subscribe(
            (evt) => {

              if (evt == 'chiudi')
                this._overlaySidePanelService.close();

            }

          );
        }, 500);

      return;


      //this.dynamicInsertPopUp.clear();

      this.popupComponentTitle = "Anagrafica Utenti";
      this.popupComponentVisible = true;
      const factory = this.componentFactoryResolver.resolveComponentFactory(AnaUtentiComponent);
      setTimeout(() => {
        this.dynamicInsertPopUp.clear();
        this.dynamicInsertPopUp.createComponent(factory, 0);
      }, 500);

    }).catch((err: HttpErrorResponse) => {
      this.spinner.hide();
      //this.appService.parseHttpErrorResponse(err);                        
    });



  };



  listSelectionChanged = (e) => {
    //this.currentLicenza = e.addedItems[0];    
    //this.currentLicenza=e.itemData

    //this.currentDB = e.addedItems[0]; 
    this.currentLicenza = e.itemData;
    console.log("Da settare ", this.currentLicenza.id);

    this.appService.SetLicenzaLavoro(this.currentLicenza.id).then(response => {
      this.spinner.hide();

      //this._overlaySidePanelService.setTitle("Utenti");
      this._overlaySidePanelService.setPopupHeight('730px');

      this._overlaySidePanelService.setContent(AnaUtentiComponent);
      this._overlaySidePanelService.show();

      setTimeout(
        () => {
          (this._overlaySidePanelService._hrefComponent.instance.onChiusuraUtentiEmitter as EventEmitter<any>).subscribe(
            (evt) => {

              if (evt == 'chiudi')
                this._overlaySidePanelService.close();

            }

          );
        }, 500);
      return;


      this.popupComponentTitle = "Anagrafica Utenti";
      this.popupComponentVisible = true;
      const factory = this.componentFactoryResolver.resolveComponentFactory(AnaUtentiComponent);
      setTimeout(() => {
        this.dynamicInsertPopUp.clear();
        this.dynamicInsertPopUp.createComponent(factory, 0);
      }, 500);

    }).catch((err: HttpErrorResponse) => {
      this.spinner.hide();
      //this.appService.parseHttpErrorResponse(err);                        
    }); // info



    //console.log(e);



  };
  ngOnInit() {
    this._overlaySidePanelService.onPanelClose().subscribe(
      (ev) => {
        //alert("wwwwwwwwwww","wwwwwwwwwwwww")
        //location.reload();
        // pop up component chiuso
      }
    )
    /*
    this._overlaySidePanelService.setTitle("TEST");
    //this._overlaySidePanelService.setContent(NicaInfoAnagraficaAziendaComponent);
    
    setTimeout(
      ()=>{


        this._overlaySidePanelService.setContent(NicaInfoAnagraficaAziendaComponent);
        this._overlaySidePanelService.show();
        this._overlaySidePanelService._hrefComponent.instance.inizializza("pippo");

        

      },200
    );
    */

    if (this.utenteService.InfoUtenteConnesso.idtipoutente == 1) {
      this.helpPage = 'UtenteOwner.html'
    }

    if (this.utenteService.InfoUtenteConnesso.idtipoutente == 2) {
      this.helpPage = 'UtenteSuperAdministrator.html'
    }

    if (this.utenteService.InfoUtenteConnesso.idtipoutente > 2) {

      this.router.navigate(['/main']);
      return
    }

    if (document.location.host == 'localhost:4200') {
      this.localhost = true;

    }
    //this.localhost=!environment.production;

    (function ($) {
    })(jQuery);


  }

  onMappaSubmit(evt: any) {

    evt.preventDefault();

  }
  openToolBar(event) {

    event.preventDefault();
    event.stopPropagation();
    this.InAttesaOpen = true;
    this.timeInterval = setTimeout(() => {
      if (!this.isOpen && this.InAttesaOpen)

        this.isOpen = true
    }, 1000);



  }
  closeToolBar(event) {
    event.preventDefault();
    event.stopPropagation()
    this.InAttesaOpen = false;
    clearTimeout(this.timeInterval);
    setTimeout(() => {
      if (this.isOpen)
        this.isOpen = false
    }, 100);
  }


  onShowing(e: any) {
    e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    e.component.content().classList.add("soggetto-form"); //add class to content


  }

  onHiding(evt) {

    this.titoloDinamico = undefined;

    if (this.attivaLicenzaForm)
      this.attivaLicenzaForm.formEdit.instance.resetValues();

    if (this.licenzaForm)
      this.licenzaForm.formEdit.instance.resetValues();


  }

  async gestisciEventoFormLicenza(evt) {

    if (typeof evt == 'string') {

      switch (evt) {

        case 'attiva': {


          if (!this.attivaLicenzaForm.formEdit.instance.validate().isValid)
            return;


          this.attivaLicenza();


        } break;

        case 'salva': {

          if (!this.licenzaForm.formEdit.formData['id'] || this.licenzaForm.formEdit.formData['isAttiva'] == undefined)
            return;

          this.spinner.show();


          this.appService.AbilitaDisabilitaLicenza({
            CodeLicenza: this.licenzaForm.formEdit.formData['id'],
            IsAbilitata: this.licenzaForm.formEdit.formData['isAttiva']
          }).then(response => {
            this.spinner.hide();
            let dt: messagefromComponent = {
              codeMessage: 0,
              destComponent: 'gridLicenze',
              traceMessage: 'refresh'
            }
            this.componentService.emitMessage(dt);


            notify({
              message: `Licenza ${this.licenzaForm.formEdit.formData['id']} ${(this.licenzaForm.formEdit.formData['isAttiva'] == false) ? 'disattivata' : 'attivata'} con successo!`,
              height: 45,
              width: 300,
              position: 'center center'
            }, "success", 2000);

            if (this.licenzaForm)
              this.licenzaForm.formEdit.instance.resetValues();

            this.popupLicenza = false;


          }).catch((err: HttpErrorResponse) => {

            this.spinner.hide();

            if (this.licenzaForm)
              this.licenzaForm.formEdit.instance.resetValues();

            this.popupLicenza = false;

          });



        } break;


        case 'annulla': {


          if (this.popupAttivaLicenza)
            this.popupAttivaLicenza = false;

          if (this.popupLicenza)
            this.popupLicenza = false;

        } break;

      }



    }




  }


}
